module.exports = "img/flags/BJ.7bd9d4c.png";